import {EvaluationsResult, ItemType} from './types'
import {Search} from './server'
import type {FilterConfig, SearchResult} from '../components/filters/types'

export const getEvaluations = async (params: FilterConfig): Promise<SearchResult> =>
  Search('/evaluation', params)

export const getEvaluationRuns = async (
  params: FilterConfig,
  group: ItemType
): Promise<EvaluationsResult> => {
  const filters = {...(params.filters || {}), binned: true}
  const query = {...params, groupBy: group, filters}
  return (await Search('/evaluationsession', query)) as unknown as EvaluationsResult
}

export const getRuns = async (params: FilterConfig): Promise<SearchResult> => {
  if (!params?.filters?.evals && !params?.filters?.models) {
    return {count: 0, items: []}
  }
  return Search('/evaluationsession', params)
}
